<!-- —————————————↓SCSS———————分界线————————————————————————— -->
<style lang="scss" scoped>
    .water-fall{
        width: 910px;
        margin: 0 auto;
        margin-top: 23px;
        position: relative;
        overflow: hidden;
        .water-fall-item{
            width: 276px;
            margin: 0 10px;
            position: absolute;
            padding: 14px 12px 10px 12px;
            background-color: #fff;
            cursor: pointer;
            .top{
                max-width: 100%;
                line-height: 42px;
                height: 42px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                img{
                    width: 42px;
                    height: 42px;
                    vertical-align: middle;
                    display: inline-block;
                    border-radius: 42px;
                    background: url(../../common/img/wo_nohead.png) no-repeat;
                    background-size: 42px;
                }
                .name{
                    font-family: PingFangSC-Regular;
                    font-size: 20px;
                    color: #444444;
                    vertical-align: middle;
                    margin-left: 11px;
                }
            }
            .middle{
                font-family: PingFangSC-Semibold;
                font-size: 28px;
                color: #444444;
                line-height: 38px;
                margin-top: 10px;
                margin-bottom: 16px;
                p{
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 10;
                    /* ! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer: on */
                    
                  img{
                    display: block;
                  }
                  span,p,i{
                        font-family: PingFangSC-Semibold!important;
                        font-size: 28px!important;
                        line-height: 38px!important;
                        color: #444!important;
                        font-weight: 500!important;
                  }
                }
                .text{
                  img{
                    display: block;
                  }
                }
                img{
                  margin-top: 17px;
                  width: 100%;
                }
            }
            .bottom{
                font-family: PingFangSC-Semibold;
                font-size: 20px;
                color: #E56800;
                line-height: 20px;
                .iconfont{
                  font-size: 24px;
                  vertical-align: middle;
                }
                .num{
                  vertical-align: middle;
                  margin-left: 7px;
                }
            }
        }
    }
</style>

<!-- —————————————↓HTML————————分界线———————————————————————— -->
<template>
    <div class="water-fall" ref="box-wraper" :style="{'height':boxHeight}"  v-scrollBar>
        <div class="water-fall-item" v-for="(item,index) in imgsArr" :key="index" :id="'item_'+item.postID"  @click="enlargeBox(item)">
            <div class="top">
                <img :src="getImg(item.headImage)" alt="">
                <span class="name">{{anonymous==0?item.userName:'匿名'}}</span>
            </div>
            <div class="middle">
              <p v-html="item.message" class="text" ref="discuss-text"></p>
              <img :src="item.location" alt="" v-if="item.location!=''"> 
            </div>
            <div class="bottom">
                <span class="iconfont icon-dianzan"></span><span class="num">{{item.praise}}</span>
            </div>
        </div>
    </div>
</template>

<!-- ——————————————↓JS—————————分界线———————————————————————— -->
<script>
export default {
  name: 'vue-waterfall-easy',
  props: {
    anonymous:{
      type:Number
    },
    reachBottomDistance: { // 滚动触底距离，触发加载新图片
      type: Number, // selector
      default: 20  // 默认在最低那一列到底时触发
    },
    loadingDotCount: { // loading 点数
      type: Number,
      default: 3
    },
    loadingDotStyle: {
      type: Object,
    },
    gap: { // .img-box 间距
      type: Number,
      default: 20
    },
    mobileGap: {
      type: Number,
      default: 8
    },
    maxCols: {
      type: Number,
      default: 5
    },
    imgsArr: {
      type: Array,
      required: true,
    },
    srcKey: {
      type: String,
      default: 'src'
    },
    hrefKey: {
      type: String,
      default: 'href'
    },
    imgWidth: {
      type: Number,
      default: 240
    },
    isRouterLink: {
      type: Boolean,
      default: false
    },
    linkRange: { // card | img | custom 自定义通过slot自定义链接范围
      type: String,
      default: 'card'
    },
    loadingTimeOut: { // 预加载事件小于500毫秒就不显示加载动画，增加用户体验
      type: Number,
      default: 500
    },
    cardAnimationClass: {
      type: [String],
      default: 'default-card-animation'
    },
    enablePullDownEvent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      msg: 'this is from vue-waterfall-easy.vue',
      isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i), // 初始化移动端
      isPreloading: true, // 正在预加载中，显示加载动画
      isPreloading_c: true,
      imgsArr_c: [], // 待图片预加载imgsArr完成，插入新的字段height之后,才会生成imgsArr_c，这时才开始渲染
      loadedCount: 0,
      cols: 3, // 需要根据窗口宽度初始化
      imgBoxEls: null, // 所有的.img-box元素
      beginIndex: 0, // 开始要排列的图片索引,首次为第二列的第一张图片，后续加载则为已经排列图片的下一个索引
      colsHeightArr: [],
      // 自定义loading
      LoadingTimer: null,
      isFirstLoad: true, // 首次加载
      over: false, // 结束waterfall加载
      boxHeight:0
    }
  },
  mounted() {
    console.log(this)
    this.boxHeight = (document.body.clientHeight-160)+'px';
    this.preload();
    this.$on('preloaded', () => {
      this.isFirstLoad = false
      this.imgsArr_c = this.imgsArr.concat([]) // 预加载完成，这时才开始渲染
        this.$nextTick(() => {
            this.isPreloading = false
            this.imgBoxEls = this.$refs['box-wraper'].getElementsByClassName('water-fall-item')
            $(this.$refs['discuss-text']).find('a').attr('href','javascript:void(0)')
            // console.log('图片总数', this.imgBoxEls.length)
            this.waterfall()
        })

    })
    // this.response()
    this.scroll()
  },
  methods:{
     preload() {
      var that = this;
      this.imgsArr.forEach((imgItem, imgIndex) => {
        if (imgIndex < that.loadedCount) return // 只对新加载图片进行预加载
        // 无图时
        if (!imgItem[this.srcKey]) {
          this.imgsArr[imgIndex]._height = '0'
          this.loadedCount++

          // 支持无图模式
          if (this.loadedCount == this.imgsArr.length) {
            this.$emit('preloaded')
          }
          return
        }
        var oImg = new Image()
        oImg.src = imgItem[that.srcKey]
        oImg.onload = oImg.onerror = (e) => {
          that.loadedCount++
          // 预加载图片，计算图片容器的高
          that.imgsArr[imgIndex]._height = e.type == 'load' ? Math.round(that.imgWidth_c / (oImg.width / oImg.height)) : (that.isMobile ? that.imgWidth_c : that.imgWidth)
          if (e.type == 'error') {
            that.imgsArr[imgIndex]._error = true
            that.$emit('imgError', that.imgsArr[imgIndex])
          }

          if (that.loadedCount == that.imgsArr.length) {
            that.$emit('preloaded')
          }
        }
      })

    },
    // ==3== waterfall布局
    waterfall() {
      if (!this.imgBoxEls) return
      // console.log('waterfall')
      var top, left, height, colWidth = 300;
      if (this.beginIndex == 0) this.colsHeightArr = []
      for (var i = this.beginIndex; i < this.imgsArr.length; i++) {
        if (!this.imgBoxEls[i]) return
        height = this.imgBoxEls[i].offsetHeight+24
        if (i < this.cols) {
          this.colsHeightArr.push(height)
          top = 0
          left = i * colWidth
        } else {
          var minHeight = Math.min.apply(null, this.colsHeightArr) // 最低高低
          var minIndex = this.colsHeightArr.indexOf(minHeight) // 最低高度的索引
          top = minHeight
          left = minIndex * colWidth
          // 设置元素定位的位置
          // 更新colsHeightArr
          this.colsHeightArr[minIndex] = minHeight + height
        }
        this.imgBoxEls[i].style.left = left + 'px'
        this.imgBoxEls[i].style.top = top + 'px'
      }
      this.beginIndex = this.imgsArr.length // 排列完之后，新增图片从这个索引开始预加载图片和排列

    },
    reset() {
      this.imgsArr_c = []
      this.beginIndex = 0
      this.loadedCount = 0
      this.isFirstLoad = true
      this.isPreloading = true
      this.scroll()
      this.over = false
    },
    // ==5== 滚动触底事件
    scrollFn() {
      var scrollEl = this.$refs['box-wraper'];
    //  if (this.isPreloading) return
      var minHeight = Math.min.apply(null, this.colsHeightArr)
      if (scrollEl.scrollTop + scrollEl.offsetHeight > minHeight - this.reachBottomDistance) {
        // this.isPreloading = true
        // console.log('scrollReachBottom')
        this.$emit('scrollReachBottom') // 滚动触底
      }
    },
    scroll() {
      this.$refs['box-wraper'].addEventListener('scroll', this.scrollFn)
    },
    waterfallOver() {
      this.$refs.scrollEl.removeEventListener('scroll', this.scrollFn)
      this.isPreloading = false
      this.over = true
      this.setOverTipPos()
    },
    setOverTipPos() {
      var maxHeight = Math.max.apply(null, this.colsHeightArr)
      this.$nextTick(() => {
        this.$refs.over.style.top = maxHeight + 'px'
      })
    },
    //放大显示内容
    enlargeBox:function(item){
      this.$emit('enlargeBox',item)
    },
    getImg(imgUrl){
      return this.common.handleImg(imgUrl,this.rescourceURL);
    }
  },
  watch: {
    imgsArr(newV, oldV) {
      if (this.imgsArr_c.length > newV.length || (this.imgsArr_c.length > 0 && newV[0] && !newV[0]._height)) {
        // console.log('reset')
        this.reset()
      }
      this.preload()
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/vueWaterFallEasy/vueWaterFallEasy.vue